<template>
  <div>
    <Mobile :name="name" :items="items" :inputData.sync="search" class="hidden-md-and-up" />
    <Desktop :name="name" :tags="tags" :items="items" :inputData.sync="search" :sorting.sync="sorting" :filtering.sync="filtering" class="hidden-sm-and-down mb-6" />
  </div>
</template>

<script>
import Desktop from "./Desktop";
import Mobile from "./Mobile";
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      items: [
        { title: "Newest top" },
        { title: "Oldest top" },
        { title: "Alphabetical" },
        { title: "Reverse alphabetical"}
      ],
      tags: [],
      search: "",
      sorting: "",
      filtering: []
    };
  },
  props: ["name"],
  components: { Mobile, Desktop },
  computed: mapGetters(["applicationProviders", "environments", "templates", "privateTemplates"]),
  watch: {
    search() {
      this.$emit("search", this.search);
    },
    sorting() {
      this.$emit("sorting", this.sorting);
    },
    filtering() {
      this.tags.forEach((tag, index) => tag.isActive=false)
      this.filtering.forEach(activeProvider => this.tags[activeProvider].isActive=true)
      this.$emit("filtering", this.tags.filter(tag => tag.isActive === true));
    }
  },
  methods: {
    ...mapActions(["getApplicationProviders"]),
    setApplicationProviders(type) {
      const providers = [...new Set(this[type].map(element => element.ApplicationProviderName))];
      this.tags = providers.length 
      ? providers.map(provider => ({
          "isActive": false,
          "title": provider
      }))
      : [{
        "isActive": false,
        "title": "All"
      }]
    }
  },
  created() {
    if(this.name === "Public templates")
      this.setApplicationProviders("templates")
    else if(this.name === "My templates")
      this.setApplicationProviders("privateTemplates")
    else
       this.setApplicationProviders("environments");
  }
};
</script>

<style>
#title:before {
  position: absolute;
  bottom: 10px;
  content: "";
  width: 40px;
  border-bottom: 2px solid #6db42c;
}

.filters,
.sorting {
  font-size: 0.7em !important;
}

.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}

p {
  font-size: 1em;
}

.search-bar {
  height: 48px;
}

.wrapper {
  width: 70% !important;
  margin: 0 auto;
  display: flex;
}

.header-title {
  padding: 0;
}

#title {
  font-weight: bold;
  font-family: "Montserrat" !important;
}
</style>